import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { select, Store } from "@ngrx/store";
import { Observable, of, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { AppStateInterface } from "src/app/store/appState.interface";
import { saveSelectedLPsSelector } from "src/app/store/locationPartner/location-partner.selectors";
import {
  invokeCompletedByAgeRangeAndGenderForAd,
  invokeCompletedByGenderDemographicForLocationPartner,
  invokeSummaryStaticsInDateBetweenForLP,
  invokeSummaryStaticsInDateBetweenForAd,
  invokeViewsByAgeRangeAndGenderByAd,
  invokeViewsByGenderDemographicForLocationPartners,
  resultSummaryStatics,
  resultGenderAgeStatistics,
  invokeFranchiseSummaryStatisticsBetweenDates,
  invokeClicksByGenderDemographicForLocationPartner,
  invokeRedirectionByAgeAndGenderForAd,
} from "src/app/store/statistics/statistics.actions";
import {
  genderAgeStatisticsForAdSelector,
  resultCompletedByGenderDemographicForLocationPartnerSelector,
  resultViewsGenderAgeStaticsForLPSelector,
  summaryStatisticsSelector,
} from "src/app/store/statistics/statistics.selectors";
import { Style } from "src/app/utils/style/style";
import { DateFilter } from "../../models/date-filte.interface";
import { InputAudience } from "../../models/input-audience.interface";
import { GenderAgeStatistics } from "../../models/statistics/gender-age-statistics";
import { SummaryStatics } from "../../models/statistics/summary-statics";
import { JwtService } from "../../services/jwt.service";
import { AudienceType } from "../../enum/chart/audiance";
import {
  invokeConsumerDemographicDetails,
  invokeCountConsumersBetweenDates,
} from "src/app/store/consumers/consumers.actions";
import { ConsumerCountByDate } from "../../models/consumers/consumerCountByDate";
import {
  consumerDemographiqueDetailsSelector,
  countConsumersBetweenDatesSelector,
} from "src/app/store/consumers/consumers.selectors";
import {
  columnChartFilter,
  FilterInterface,
  splineChartFilter,
} from "../../data/filter-data";
import {
  audienceData,
  ExportData,
  exportDataType,
} from "../../data/exportData";
import { RoleEnum } from "../../models/user/role.interface";
import { ChartStatus, ChartStatusToShow } from "../../enum/chartStatus";
import { TranslateService } from "@ngx-translate/core";
import { invokeApiDistroyed } from "src/app/store/apiState.interface";
import { LocationAndDateFilter } from "../../models/LocationAndDateFilter";
import { SelectedLps } from "../../models/location-partners/selectedLps";
import { CampaignStatusEnum } from "../../enum/campaign-status";
import { AdvertisingCampaignInterface } from "../../models/advertising-campaigns/advertising-campaign.interface";
import { getAdCompaignByHashedIdSelector } from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import { RefreshButtonState } from "../../enum/refreshButtonState";
import { FeatureName } from "../../enum/feature-name.enum";
import { UserFeatureDto } from "../../models/features/user-feature-dto.interface";
import { allFeaturesSelector } from "src/app/store/features/features.selectors";
import { ObjectiveTypeEnum } from "../../enum/objectives";

@Component({
  selector: "app-audience",
  templateUrl: "./audience.component.html",
})
export class AudienceComponent extends BaseComponent implements OnInit {
  form: FormGroup;
  Audience: ExportData[] = audienceData;
  @Input() isPremium: boolean;
  @Input() isConsummer: boolean = false;
  @Output() resultSummaryChart = new EventEmitter<SummaryStatics>();
  @Output() optionSelected = new EventEmitter<string>();
  @Output() genderAgeStatics = new EventEmitter<GenderAgeStatistics | null>();
  @Output() genderAgeStaticsForAd =
    new EventEmitter<GenderAgeStatistics | null>();
  @Input() type: string;
  // @Input() title: string;
  @Input("inputAudience$") inputAudience$: Observable<InputAudience> = of({
    name: null,
    type: null,
    title: null,
    titleSpline: "invoices.summary",
    titleColumnChart: "invoices.distributionAgeGender",
    email: "",
  });
  audienceType = AudienceType;
  inputAudience: InputAudience = {
    name: null,
    type: null,
    title: null,
    titleSpline: "invoices.summary",
    titleColumnChart: "invoices.distributionAgeGender",
    email: "",
  };
  summaryChart = {
    title: "Summary chart",
    yaxisTitle: "Charts.nombreViews",
    xaxisTitle: "Charts.days",
    xaxis: {
      title: { text: "Charts.days" },
    },
    seriesTitles: ["Impressions", "Unique views", "Engagement"],
  };
  columnChart = {
    title: "Données démographiques",
    yaxisTitle: "Charts.nombreViews",
    xaxisTitle: "Days",
    xaxis: {
      title: { text: "Days" },
      categories: Style.ageRange,
    },

    seriesTitles: ["Impressions", "Unique views", "Engagement"],
  };
  receivedChart: any;
  dashboardLP: boolean = false;

  resultSummaryChartForLP: SummaryStatics | null;
  resultSummaryResult$: Observable<SummaryStatics | null>;
  summaryStatics: SummaryStatics | null;
  resultSummaryChartBetweenDates: SummaryStatics | null;
  @Input() startDate: Date;
  @Input() endDate: Date;

  genderAgeStaticsForAd$: Observable<GenderAgeStatistics | null>;
  resultGenderAgeStatics: GenderAgeStatistics | null;
  resultViewsByGenderDemographicForLP$: Observable<GenderAgeStatistics | null>;
  resultViewsByGenderDemographicForLP: GenderAgeStatistics | null;
  resultCompletedByGenderDemographicForLP$: Observable<GenderAgeStatistics | null>;
  resulCompletedByGenderDemographicForLP: GenderAgeStatistics | null;
  lp: string;
  @Input() adTitle: string | null;
  companyName: string;
  countConsumersByDate$: Observable<ConsumerCountByDate | null>;
  filterColumnChart: FilterInterface = columnChartFilter;
  filterSpline: FilterInterface = splineChartFilter;

  selectedLps: string[] = [];
  saveSelectedLP$: Observable<SelectedLps | null>;
  selectedOption: string | null = null;

  title: string;
  seriesTitles: string[] = [];
  yaxisTitle: string;
  isAdFinished: boolean;
  adCompaignByHashedId$: Observable<AdvertisingCampaignInterface | null>;
  cachedAt: Date | null;
  loading: boolean;
  resultSummaryLoading: boolean;
  consumerDemographicDetails$: Observable<GenderAgeStatistics | null>;
  fetchingResultSummaryState: RefreshButtonState = RefreshButtonState.IDLE;
  fetchingSummary: boolean = false;
  fetchingAgeGenerStats: boolean = false;
  fetchingFromCache: boolean = false;
  currentTimeout: NodeJS.Timeout | null = null;

  roleName: string;
  features$: Observable<UserFeatureDto[] | null>;
  objectiveName: ObjectiveTypeEnum;

  @Output() resetChart = new EventEmitter<boolean>();
  constructor(
    private fb: FormBuilder,
    private store: Store<AppStateInterface>,
    private jwtService: JwtService,
    private translate: TranslateService
  ) {
    super(store);
    this.adCompaignByHashedId$ = this.store
      .pipe(select(getAdCompaignByHashedIdSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.resultViewsByGenderDemographicForLP$ = this.store
      .pipe(select(resultViewsGenderAgeStaticsForLPSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.resultCompletedByGenderDemographicForLP$ = this.store
      .pipe(
        select(resultCompletedByGenderDemographicForLocationPartnerSelector)
      )
      .pipe(takeUntil(this.ngDestroyed$));
    this.resultSummaryResult$ = this.store
      .pipe(select(summaryStatisticsSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.genderAgeStaticsForAd$ = this.store
      .pipe(select(genderAgeStatisticsForAdSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.countConsumersByDate$ = this.store
      .pipe(select(countConsumersBetweenDatesSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.saveSelectedLP$ = this.store
      .pipe(select(saveSelectedLPsSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.consumerDemographicDetails$ = this.store
      .pipe(select(consumerDemographiqueDetailsSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.features$ = this.store
      .pipe(select(allFeaturesSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.roleName = this.jwtService.getRoleName(this.jwtService.getToken());
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      dateChart: [[this.startDate, this.endDate]],
    });
    if (this.inputAudience.title) this.title = this.inputAudience.title;
    this.saveSelectedLP$.subscribe((data) => {
      if (data) {
        this.selectedLps = data.companyNames;
      }
      this.getChartInDate(false);
    });
    this.updateColumnChartFilters();
    this.filterSpline.name.map(
      (e) =>
        (e.data = Object.keys(ChartStatus)
          .filter((value) => isNaN(Number(value)) === true)
          .map(
            (key: string | any) =>
              ChartStatusToShow[key as keyof typeof ChartStatus]
          ))
    );
    this.store.dispatch(resultSummaryStatics({ summaryStatistic: null }));
    this.store.dispatch(
      resultGenderAgeStatistics({
        genderAgeStatistics: null,
      })
    );
    this.inputAudience$.subscribe((input) => {
      if (input.type != null) {
        this.inputAudience = input;
        this.updateColumnChartFilters();
        if (this.isPremium) {
          this.getChartInDate(false);
        }
        this.features$.subscribe((result) => {
          if (result) {
            const findPremiumFeature = result.find(
              (feature) => feature.name === FeatureName.PREMIUM
            );
            if (
              findPremiumFeature &&
              findPremiumFeature.endDate &&
              new Date(findPremiumFeature.endDate) > new Date()
            ) {
              this.isPremium = true;
              this.getChartInDate(false);
            }
          }
        });
      }
    });
    this.resultViewsByGenderDemographicForLP$.subscribe(
      (result: GenderAgeStatistics | null) => {
        if (result != null) {
          this.genderAgeStatics.emit(result);
          this.exportCsvDemographicChart(result);
        }
      }
    );
    this.resultSummaryResult$.subscribe((result: SummaryStatics | null) => {
      if (result != null) {
        this.summaryStatics = result;
        this.cachedAt = result.cachedAt;
        this.resultSummaryChart.emit(result);
        this.seriesTitles = this.summaryChart.seriesTitles;
        this.yaxisTitle = this.summaryChart.yaxisTitle;
        const csvRows: string[] = [];
        let translatedHeaders: string[] = [];

        if (this.summaryStatics != null) {
          let headers = Object.keys(this.summaryStatics).filter(
            (key) => key !== "cachedAt"
          );
          if (!this.conditionToShowClicks()) {
            headers = headers.filter((h) => h !== "redirection");
          }

          translatedHeaders = headers.map((key) =>
            this.translate.instant(`summaryStatics.${key}`)
          );

          for (let i = 0; i < this.summaryStatics.dates.length; i++) {
            const rowData: Record<string, any> = {
              dates: this.summaryStatics.dates[i],
              views: this.summaryStatics.views[i],
              redirection: this.summaryStatics.redirection[i],
              peopleFinishAds: this.summaryStatics.peopleFinishAds[i],
              users: this.summaryStatics.users[i],
            };

            const cols = headers.map((key) => rowData[key]);
            csvRows.push(cols.join(","));
          }
        }

        for (let i = 0; i < this.Audience.length; i++) {
          if (this.Audience[i].type == exportDataType.INVOICES_SUMMARY) {
            this.Audience[i].data = [
              translatedHeaders.join(","),
              ...csvRows,
            ].join("\n");
          }

          if (this.form.get("dateChart")?.value[0] != null) {
            this.Audience[i].dates = this.form.get("dateChart")?.value;
          }
        }
      }
    });
    this.genderAgeStaticsForAd$.subscribe(
      (result: GenderAgeStatistics | null) => {
        if (result != null) {
          this.resultGenderAgeStatics = result;
          this.genderAgeStatics.emit(result);
          this.exportCsvDemographicChart(result);
        }
      }
    );
    this.countConsumersByDate$.subscribe(
      (result: ConsumerCountByDate | null) => {
        if (result != null) {
          this.cachedAt = result.cachedAt;
          this.resultSummaryChart.emit({
            dates: result.dates,
            views: result.count,
            peopleFinishAds: [],
            redirection: [],
            users: [],
            cachedAt: result.cachedAt,
          });
          this.seriesTitles = [];
          this.yaxisTitle = "Charts.consumers";
          const csvRows = [];
          let headers;
          if (result != null) {
            headers = Object.keys(result).filter((key) => key !== "cachetAt");
            for (let i = 0; i < result.dates.length; i++) {
              const cols = [result.dates[i], result.count[i]];
              csvRows.push(cols.join(","));
            }
          }
          for (let i = 0; i < this.Audience.length; i++) {
            if (this.Audience[i].type == exportDataType.INVOICES_SUMMARY)
              this.Audience[i].data = [headers, ...csvRows].join("\n");
            if (this.form.get("dateChart")?.value[0] != null) {
              this.Audience[i].dates = this.form.get("dateChart")?.value;
            }
          }
        }
      }
    );

    this.consumerDemographicDetails$.subscribe(
      (result: GenderAgeStatistics | null) => {
        if (result != null) {
          this.exportCsvDemographicChart(result);
        }
      }
    );

    this.form.valueChanges.subscribe((changes) => {
      this.startDate = changes.dateChart[0];
      this.endDate = changes.dateChart[1];
      this.getChartInDate(false);
    });
  }
  exportCsvDemographicChart(result: GenderAgeStatistics) {
    let csvRows: string[] = [];
    let headers = [];
    headers.push("age");
    headers.push(Object.keys(result));
    for (let i = 0; i < result.female.length; i++) {
      const cols = [
        this.translate.instant(Style.ageRange[i]),
        result.male[i],
        result.female[i],
      ];
      csvRows.push(cols.join(","));
    }
    for (let i = 0; i < this.Audience.length; i++) {
      if (
        this.Audience[i].type == exportDataType.INVOICES_DISTRIBUTION_AGE_GENDER
      )
        this.Audience[i].data = [headers, ...csvRows].join("\n");
    }
  }
  getChartInDate(refreshCache: boolean) {
    this.loading = true;
    const dateFilter: DateFilter = {
      startDate: this.startDate,
      endDate: this.endDate,
    };
    switch (this.inputAudience.type) {
      case AudienceType.LOCATION:
        if (
          this.isPremium ||
          this.roleName === RoleEnum.ROLE_ADMIN ||
          this.roleName === RoleEnum.ROLE_FRANCHISE
        ) {
          this.store.dispatch(
            invokeSummaryStaticsInDateBetweenForLP({
              companyName: this.inputAudience.name ?? "",
              dateFilter: dateFilter,
              refreshCache: refreshCache,
            })
          );
          this.store.dispatch(
            invokeViewsByGenderDemographicForLocationPartners({
              email: this.inputAudience.email,
              forMap: false,
              dateFilter: dateFilter,
              refreshCache: refreshCache,
            })
          );
        } else {
          this.store.dispatch(resultSummaryStatics({ summaryStatistic: null }));
          this.store.dispatch(
            resultGenderAgeStatistics({
              genderAgeStatistics: null,
            })
          );
        }
        break;
      case AudienceType.INSIGHTS:
        this.adCompaignByHashedId$.subscribe((result) => {
          if (result) {
            this.isAdFinished = result.status == CampaignStatusEnum.FINISHED;
            const filter: LocationAndDateFilter = {
              startDate: this.startDate,
              endDate: this.endDate,
              locationPartner: this.selectedLps,
              finished: result.status == CampaignStatusEnum.FINISHED,
            };
            this.store.dispatch(
              invokeSummaryStaticsInDateBetweenForAd({
                campaignHashedId: this.inputAudience.name,
                refreshCache: refreshCache,
                filter: filter,
              })
            );
            this.store.dispatch(
              invokeViewsByAgeRangeAndGenderByAd({
                filter: filter,
                campaignHashedId: this.inputAudience.name,
                refreshCache: refreshCache,
              })
            );
            this.objectiveName = result.objectiveName;
            this.updateColumnChartFilters();
          }
        });
        break;
      case AudienceType.CONSUMERS: {
        this.store.dispatch(
          invokeCountConsumersBetweenDates({
            dateFilter: dateFilter,
            refreshCache: refreshCache,
          })
        );

        this.store.dispatch(
          invokeConsumerDemographicDetails({
            dateFilter: dateFilter,
            refreshCache: refreshCache,
          })
        );
        break;
      }
      case AudienceType.FRANCHISE: {
        if (this.isPremium) {
          this.store.dispatch(
            invokeFranchiseSummaryStatisticsBetweenDates({
              dateFilter: dateFilter,
              refreshCache: refreshCache,
              companyName: this.inputAudience.name ?? "",
            })
          );
          this.store.dispatch(
            invokeViewsByGenderDemographicForLocationPartners({
              email: this.inputAudience.email,
              forMap: false,
              dateFilter: dateFilter,
              refreshCache: refreshCache,
            })
          );
        } else {
        }
        break;
      }
      default:
        break;
    }
  }
  resultOptionClicked(option: string) {
    this.optionSelected.emit(option);
  }
  saveOption(option: string) {
    const scrollY = window.scrollY;
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY);
    });
    if (this.selectedOption) {
      this.store.dispatch(invokeApiDistroyed());
    }
    const KeyFound = Object.keys(ChartStatusToShow).find(
      (key) => ChartStatusToShow[key as ChartStatus] === option
    );
    if (KeyFound) {
      this.selectedOption = KeyFound;
    }
    const filter: LocationAndDateFilter = {
      startDate: this.startDate,
      endDate: this.endDate,
      locationPartner: this.selectedLps,
      finished: this.isAdFinished,
    };
    const dateFilter: DateFilter = {
      startDate: this.startDate,
      endDate: this.endDate,
    };
    if (this.inputAudience.type == AudienceType.LOCATION) {
      switch (KeyFound) {
        case ChartStatus.ENGAGEMENT:
          this.store.dispatch(
            invokeCompletedByGenderDemographicForLocationPartner({
              email: this.inputAudience.email,
              filter: dateFilter,
            })
          );
          break;
        case ChartStatus.VIEWS:
          this.store.dispatch(
            invokeViewsByGenderDemographicForLocationPartners({
              email: this.inputAudience.email,
              forMap: false,
              dateFilter: dateFilter,
              refreshCache: false,
            })
          );
          break;
        case ChartStatus.CLICKS:
          this.store.dispatch(
            invokeClicksByGenderDemographicForLocationPartner({
              email: this.inputAudience.email,
              dateFilter: dateFilter,
            })
          );
          break;
        default:
          break;
      }
    }
    if (this.inputAudience.type == AudienceType.INSIGHTS) {
      switch (KeyFound) {
        case ChartStatus.ENGAGEMENT:
          this.store.dispatch(
            invokeCompletedByAgeRangeAndGenderForAd({
              campaignHashedId: this.inputAudience.name,
              filter: filter,
            })
          );
          break;
        case ChartStatus.VIEWS:
          this.store.dispatch(
            invokeViewsByAgeRangeAndGenderByAd({
              filter: filter,
              campaignHashedId: this.inputAudience.name,
              refreshCache: false,
            })
          );
          break;
        case ChartStatus.CLICKS:
          this.store.dispatch(
            invokeRedirectionByAgeAndGenderForAd({
              campaignHashedId: this.inputAudience.name,
              filter: filter,
            })
          );
          break;
        default:
          break;
      }
    }
    if (this.inputAudience.type == AudienceType.FRANCHISE) {
      switch (KeyFound) {
        case ChartStatus.ENGAGEMENT:
          this.store.dispatch(
            invokeCompletedByGenderDemographicForLocationPartner({
              email: this.inputAudience.email,
              filter: dateFilter,
            })
          );
          break;
        case ChartStatus.VIEWS:
          this.store.dispatch(
            invokeViewsByGenderDemographicForLocationPartners({
              email: this.inputAudience.email,
              forMap: false,
              dateFilter: dateFilter,
              refreshCache: false,
            })
          );
          break;
        case ChartStatus.CLICKS:
          this.store.dispatch(
            invokeClicksByGenderDemographicForLocationPartner({
              email: this.inputAudience.email,
              dateFilter: dateFilter,
            })
          );
          break;
        default:
          break;
      }
    }
  }
  chart(chart: any) {
    this.receivedChart = chart;
  }

  refreshChartInDate(refreshCache: boolean) {
    if (refreshCache) {
      this.fetchingFromCache = true;
      this.fetchingSummary = true;
      this.fetchingAgeGenerStats = true;
      this.resetChart.emit(true);
    }
    this.getChartInDate(refreshCache);
  }
  handleLoadingStateChange(isLoading: boolean) {
    this.fetchingSummary = isLoading;
    this.handleChartAndAgeLoadingStateChange();
  }

  handleAgeStatsLoadingStateChanged(isAgeStatsLoading: boolean) {
    this.fetchingAgeGenerStats = isAgeStatsLoading;
    this.handleChartAndAgeLoadingStateChange();
  }

  handleChartAndAgeLoadingStateChange() {
    if (!this.fetchingFromCache) return;
    if (this.fetchingSummary || this.fetchingAgeGenerStats) {
      if (this.currentTimeout) {
        clearTimeout(this.currentTimeout);
      }
      this.fetchingResultSummaryState = RefreshButtonState.LOADING;
    } else {
      this.fetchingResultSummaryState = RefreshButtonState.SUCCESS;
      this.currentTimeout = setTimeout(
        () => (this.fetchingResultSummaryState = RefreshButtonState.IDLE),
        2500
      );
      this.fetchingFromCache = false;
    }
  }

  conditionToShowClicks() {
    return (
      this.objectiveName !== ObjectiveTypeEnum.BRAND_AWARENESS_AND_REACH &&
      (this.inputAudience.type === AudienceType.INSIGHTS ||
        (this.roleName === RoleEnum.ROLE_ADMIN &&
          (this.inputAudience.type === AudienceType.LOCATION ||
            this.inputAudience.type === AudienceType.FRANCHISE)))
    );
  }

  updateColumnChartFilters() {
    this.filterColumnChart.name.map((e) => {
      const keys = Object.keys(ChartStatus)
        .filter((value) => isNaN(Number(value)))
        .filter((key) => {
          if (!this.conditionToShowClicks()) {
            return key !== ChartStatus.CLICKS;
          }
          return true;
        });

      e.data = keys.map(
        (key: string) => ChartStatusToShow[key as keyof typeof ChartStatus]
      );
    });
  }
}
